import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/videos/phone.mp4'


const _withScopeId = n => (_pushScopeId("data-v-70a102ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blocks" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "blocks-half--block-text-settings top--text" }, "We are create apps for any business case", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  autoplay: "autoplay",
  muted: "muted",
  loop: "loop",
  class: "blocks-half--block-video",
  playsinline: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "blocks-half--block-text-settings bottom--text" }, "With business level controls", -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blocks-half--block white" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "blocks-half--block-text-settings black--text" }, "We manage projects and know"),
  /*#__PURE__*/_createElementVNode("h3", { class: "blocks-half--block-text-settings black--text bottom" }, "how to build methodologies correctly.")
], -1))

import { inject, reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = reactive({
  isTablet: inject('isTablet')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["blocks-half--block black", {tablet: _unref(data).isTablet}])
      }, _hoisted_6, 2),
      _hoisted_7
    ])
  ]))
}
}

})